"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _Typography = _interopRequireDefault(require("../Typography"));

var _OldButton = _interopRequireDefault(require("../OldButton"));

var _Box = _interopRequireDefault(require("../Box"));

var _Stack = _interopRequireDefault(require("../Stack"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function CameraView(props) {
  let {
    cameraComponent: Camera
  } = props;
  let [_hasPermission, setHasPermission] = (0, _react.useState)(null);
  let [capturing, setCapturing] = (0, _react.useState)(false);
  let cameraRef = (0, _react.useRef)(null);
  let [flashMode, setFlashMode] = (0, _react.useState)("off");
  (0, _react.useEffect)(() => {
    async function requestPermission() {
      const {
        status
      } = await Camera.requestPermissionsAsync();
      setHasPermission(status === "granted");
    }

    if (_reactNative.Platform.OS !== "web") {
      requestPermission();
    } else {
      setHasPermission(true);
    }

    (async () => {
      // @ts-ignore farzad will fix
      let camera = cameraRef.current;

      if (camera) {
        await camera.getAvailablePictureSizesAsync("4:3");
      }
    })();
  }, []); // if (hasPermission === null) {
  //   return <View />;
  // }
  // if (hasPermission === false) {
  //   return <Text>No access to camera</Text>;
  // }

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/_react.default.createElement(Camera, {
    autoFocus: "off",
    style: {
      flex: 1
    },
    pictureSize: "640x480",
    type: "back",
    ref: cameraRef,
    flashMode: flashMode
  }, props.flashMode ? /*#__PURE__*/_react.default.createElement(_Stack.default, {
    alignment: "start",
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    p: "l"
  }, /*#__PURE__*/_react.default.createElement(_OldButton.default, {
    size: "l",
    type: "circle-like",
    bg: "common.white",
    disabled: capturing,
    onPress: () => setFlashMode(flashMode == "torch" ? "off" : "torch")
  }, props.flashMode(flashMode)))) : null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    pb: "xxxl",
    style: {
      flex: 1,
      flexDirection: "column-reverse",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_OldButton.default, {
    onPress: async () => {
      let camera = cameraRef.current;

      if (camera) {
        setCapturing(true);

        try {
          // @ts-ignore
          let data = await camera.takePictureAsync({
            base64: true,
            // quality: 0.5,
            // IMPORTANT: Some android devices will crash
            skipProcessing: true
          });
          let dataUri;

          if (_reactNative.Platform.OS === "web") {
            dataUri = data.base64;
          } else {
            dataUri = `data:image/jpg;base64,${data.base64}`;
          }

          let output = {
            uri: data.uri,
            dataUri,
            width: data.width,
            height: data.height
          };
          props.onCapture(output);
        } catch {
          if (props.onFailed) {
            props.onFailed();
          }
        } finally {
          setCapturing(false);
        }
      }
    },
    size: "l",
    type: "circle-like",
    bg: "green.main",
    disabled: capturing
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "common.white",
    aligment: "center"
  }, "\u062B\u0628\u0640\u0640\u0640\u0640\u062A \u0639\u0640\u0640\u0640\u06A9\u0633")))));
}

var _default = CameraView;
exports.default = _default;